import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockVideoFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 * Lazy per the block-loading rule: not on the critical rendering path.
 */
export const videoBlockConfig = {
  name: 'inner-block-video',
  component: defineAsyncComponent(() => import('./CmsVideoBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('@pkg/ui/components/base/Video.vue')),
  fields: blockVideoFields,
} satisfies ModularBlockConfig;
